import React, { FC, useContext, useEffect, useRef, useState } from "react";
//import Heading from "components/Heading/Heading";
import { DEMO_POSTS } from "data/posts";
import { PostDataType } from "data/types";


//import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
//'import Avatar from "./Avatar";
//import FooterNav from "components_custom/FooterNav/FooterNav";
import { useNavigate, useParams } from "react-router-dom";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import { ArrowSmallLeftIcon, PhotoIcon } from "@heroicons/react/24/outline";
import { GlobalDataContext } from "contexts/GlobalData";
import { requestAPI } from "utils/api";
import PictureUpload from "./PictureUpload";

// THIS IS DEMO FOR MAIN DEMO
// OTHER DEMO WILL PASS PROPS
const postsDemo: PostDataType[] = DEMO_POSTS.filter((_, i) => i > 7 && i < 14);
//
export interface SectionLatestPostsProps {
	posts?: PostDataType[];
	className?: string;
	postCardName?: "card3";
}

const ReservationModifyPassport: FC<SectionLatestPostsProps> = ({
	posts = postsDemo,
	postCardName = "card3",
	className = "",
}) => {

	const { id, idx } = useParams();

	const buttonRef = useRef (null);

	const navigate = useNavigate ();

	const { 
		initData,
		setInitData,
	} = useContext (GlobalDataContext);

	const [ passportUrl, setPassportUrl ] = useState <any> ("");
	const [ newPassportUrl, setNewPassportUrl ] = useState <string> ("");


	useEffect(()=>{
		
		if (initData.token_info.permission_group === "guest") {

			navigate('/me')	
		} else {
			(async () => {

				const res: any = await requestAPI('GET', `v1/reserve/${id}`, null);

				const traveler = res.data.info.traveler[Number(idx)];

				setPassportUrl(traveler.passportUrl);

				//console.log(traveler);
			})();
		}
		
	}, []);

	
    
	
	
	const handleBack = () => {
		navigate(`/reservation/${id}`);
	}


	return (
		<>
			
			<div className={`container relative nc-SectionLatestPosts overflow-y ${className} h-screen bg-white !p-0 lg:w-[768px]`}>

				<div className="sticky inset-0 bg-white z-40 flex items-center justify-between">
					<div className="container flex items-center justify-between sm:w-[768px] !p-0 h-[62px]">
						<div className=" top-0 pt-4 pb-4 flex items-center justify-between bg-white">
							<button
								className="focus:outline-none focus:ring-0 w-10 h-10 rounded-full flex items-center justify-center hover:bg-neutral-100 ml-2"
								onClick={()=> handleBack()}
							>
								<ArrowSmallLeftIcon className="w-6 h-6" />
							</button>
							{/* <LikeSaveBtns /> */}
							<span
								className="text-xl"
							>
								뒤로
							</span>
						</div>
					</div>
				</div>

				<div className="flex flex-col lg:flex-row">
					<div className="w-full pl-[1rem] pr-[1rem]">
						<div className="mt-5" />
						<div
							className={`nc-Section-Heading relative flex flex-col sm:flex-row sm:items-end justify-between ${className}`}
							>
							<div
								className={`max-w-2xl`}
							>
								<h2 className="text-[1.2rem] font-semibold flex-grow" style={{fontWeight: "600", color:"#282f33"}}>
									여권 수정
								</h2>
							</div>
						</div>

						<div className="mt-2" />
						
						<div>
							<span
								className={`block mt-[2px] text-[1.0rem]`}
								style={{fontWeight: "500", color:"#586066"}}
							>
								변경하실 여권을 올려주세요
							</span>
						</div>
						

						<div className="mt-10" />

						<div className="mt-10 md:ml-10 md:mr-10">
							
						<PictureUpload
							type={"passport"}
							productId={id}
							travelerNo={idx}
							label={"여권"} 
							url={passportUrl}
						/>
							
						</div>
					</div>

				</div>
				
			</div>
		</> 
	);
};

export default ReservationModifyPassport;
